import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { furnitureCatalog } from '../../../mocks/furniture-catalog';

export default function FurnitureCollectionSection() {
  const { t } = useTranslation('common');
  const [selectedFurniture, setSelectedFurniture] = useState<number | null>(null);
  const [showCatalog, setShowCatalog] = useState(false);
  
  const collections = [
    {
      id: 1,
      name: t('furniture.organicTables'),
      category: t('furniture.organicTablesDesc'),
      image: 'https://public.readdy.ai/ai/img_res/264c68d3b84214144f3020e843a0a4d3.jpg',
      bgColor: '#E8D5C4',
      details: {
        description: 'Doğal ahşabın benzersiz dokusunu ve organik formlarını yansıtan özel tasarım masalar. Her biri el işçiliği ile üretilmiş, eşsiz sanat eserleridir.',
        materials: ['Masif Ceviz Ahşap', 'Doğal Kenar Detayları', 'Çevre Dostu Vernik'],
        dimensions: '200cm x 100cm x 75cm',
        features: ['El yapımı', 'Özel tasarım', 'Doğal ahşap', 'Uzun ömürlü'],
        gallery: [
          'https://readdy.ai/api/search-image?query=organic%20wooden%20dining%20table%20natural%20edge%20live%20edge%20design%20handcrafted%20furniture%20minimalist%20background%20studio%20shot&width=800&height=600&seq=furniture-1-gallery-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=wooden%20table%20detail%20shot%20natural%20wood%20grain%20texture%20close%20up%20artisan%20craftsmanship%20minimalist%20background&width=800&height=600&seq=furniture-1-gallery-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=dining%20table%20in%20modern%20interior%20natural%20wood%20furniture%20elegant%20room%20setting%20minimalist%20design&width=800&height=600&seq=furniture-1-gallery-3&orientation=landscape'
        ]
      }
    },
    {
      id: 2,
      name: t('furniture.sculptural'),
      category: t('furniture.sculpturalDesc'),
      image: 'https://readdy.ai/api/search-image?query=modern%20organic%20armchair%20with%20natural%20fabric%20upholstery%20wooden%20legs%20minimalist%20design%20handcrafted%20furniture%20simple%20clean%20background%20studio%20photography%20elegant%20seating&width=500&height=700&seq=furniture-2&orientation=portrait',
      bgColor: '#C9D5C0',
      details: {
        description: 'Konfor ve estetiği bir araya getiren, organik formlarla tasarlanmış modern koltuklar. Doğal kumaşlar ve ahşap detaylarla zenginleştirilmiştir.',
        materials: ['Doğal Keten Kumaş', 'Meşe Ahşap Ayaklar', 'Yüksek Yoğunluklu Sünger'],
        dimensions: '85cm x 90cm x 95cm',
        features: ['Ergonomik tasarım', 'Doğal kumaş', 'Rahat oturma', 'Modern stil'],
        gallery: [
          'https://readdy.ai/api/search-image?query=modern%20organic%20armchair%20natural%20fabric%20upholstery%20wooden%20legs%20minimalist%20design%20studio%20photography&width=800&height=600&seq=furniture-2-gallery-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=armchair%20detail%20shot%20fabric%20texture%20wooden%20legs%20close%20up%20modern%20furniture%20minimalist%20background&width=800&height=600&seq=furniture-2-gallery-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=armchair%20in%20living%20room%20interior%20modern%20furniture%20natural%20materials%20elegant%20space%20minimalist%20design&width=800&height=600&seq=furniture-2-gallery-3&orientation=landscape'
        ]
      }
    },
    {
      id: 3,
      name: t('furniture.storage'),
      category: t('furniture.storageDesc'),
      image: 'https://readdy.ai/api/search-image?query=sculptural%20wooden%20shelf%20system%20with%20organic%20flowing%20shapes%20natural%20wood%20grain%20modern%20storage%20furniture%20minimalist%20background%20clean%20studio%20shot%20contemporary%20design&width=500&height=700&seq=furniture-3&orientation=portrait',
      bgColor: '#D4D0C8',
      details: {
        description: 'Akıcı formlar ve organik şekillerle tasarlanmış, işlevsel ve estetik depolama çözümleri. Modern yaşam alanları için mükemmel.',
        materials: ['Masif Meşe Ahşap', 'Metal Bağlantı Elemanları', 'Doğal Yağ Kaplama'],
        dimensions: '180cm x 40cm x 200cm',
        features: ['Modüler sistem', 'Geniş depolama', 'Şık tasarım', 'Dayanıklı yapı'],
        gallery: [
          'https://readdy.ai/api/search-image?query=sculptural%20wooden%20shelf%20system%20organic%20flowing%20shapes%20natural%20wood%20modern%20storage%20furniture%20studio%20shot&width=800&height=600&seq=furniture-3-gallery-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=wooden%20shelf%20detail%20shot%20wood%20grain%20texture%20close%20up%20modern%20furniture%20minimalist%20background&width=800&height=600&seq=furniture-3-gallery-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=shelf%20system%20in%20modern%20interior%20storage%20furniture%20natural%20wood%20elegant%20room%20minimalist%20design&width=800&height=600&seq=furniture-3-gallery-3&orientation=landscape'
        ]
      }
    },
    {
      id: 4,
      name: t('furniture.lighting'),
      category: t('furniture.lightingDesc'),
      image: 'https://readdy.ai/api/search-image?query=handcrafted%20pendant%20lamp%20made%20from%20natural%20raw%20materials%20organic%20woven%20rattan%20bamboo%20fibers%20warm%20ambient%20lighting%20artisan%20craftsmanship%20minimalist%20clean%20white%20background%20studio%20photography%20elegant%20sustainable%20design&width=500&height=700&seq=furniture-4-lighting&orientation=portrait',
      bgColor: '#D9C5C3',
      details: {
        description: 'Ham maddelerden el işçiliği ile üretilmiş, doğal ve sürdürülebilir aydınlatma çözümleri. Organik formlar ve sıcak ışık ile mekanlarınıza doğallık katın.',
        materials: ['Doğal Rattan', 'Bambu Lifleri', 'El Örgü Tekniği'],
        dimensions: '45cm x 45cm x 60cm',
        features: ['El yapımı', 'Doğal malzeme', 'Sıcak ışık', 'Sürdürülebilir'],
        gallery: [
          'https://readdy.ai/api/search-image?query=handcrafted%20pendant%20lamp%20natural%20rattan%20bamboo%20woven%20design%20warm%20lighting%20minimalist%20background%20studio%20shot&width=800&height=600&seq=furniture-4-gallery-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=pendant%20lamp%20detail%20shot%20natural%20fiber%20texture%20weaving%20pattern%20close%20up%20artisan%20craftsmanship%20minimalist%20background&width=800&height=600&seq=furniture-4-gallery-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=pendant%20lamp%20in%20modern%20interior%20natural%20lighting%20fixture%20warm%20ambiance%20elegant%20room%20minimalist%20design&width=800&height=600&seq=furniture-4-gallery-3&orientation=landscape'
        ]
      }
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openFurnitureModal = (furnitureId: number) => {
    setSelectedFurniture(furnitureId);
    document.body.style.overflow = 'hidden';
  };

  const closeFurnitureModal = () => {
    setSelectedFurniture(null);
    document.body.style.overflow = 'auto';
  };

  const currentFurniture = collections.find(f => f.id === selectedFurniture);

  return (
    <>
      <section id="furniture" className="py-32 bg-[#FAF9F7]">
        <div className="max-w-[1440px] mx-auto px-8 lg:px-16">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex items-start justify-between mb-20"
          >
            <div>
              <p className="text-sm text-gray-600 font-light mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                {t('footer.services')}
              </p>
              <h2 className="text-5xl md:text-6xl leading-tight">
                <div className="font-normal" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {t('furniture.title')}
                </div>
                <div className="font-light italic mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {t('furniture.subtitle')}
                </div>
              </h2>
            </div>
            <div className="hidden lg:block">
              <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                <path d="M60 10C80 10 100 30 100 50C100 70 80 90 60 90C40 90 20 70 20 50C20 30 40 10 60 10Z" fill="#E8D5C4" opacity="0.3"/>
              </svg>
            </div>
          </motion.div>

          {/* Collection Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
            {collections.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                onClick={() => openFurnitureModal(item.id)}
                className="group cursor-pointer"
              >
                <div className="rounded-[45px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
                  <div 
                    className="relative h-[450px] flex items-center justify-center overflow-hidden"
                    style={{ backgroundColor: item.bgColor }}
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-500 flex items-center justify-center">
                      <span className="text-white text-lg font-light opacity-0 group-hover:opacity-100 transition-opacity duration-500 whitespace-nowrap">
                        Detayları Görüntüle
                      </span>
                    </div>
                  </div>
                  <div className="bg-white p-6 h-[90px] flex flex-col justify-center">
                    <p className="text-xs uppercase tracking-widest text-gray-500 mb-2" style={{ letterSpacing: '1px' }}>
                      {item.category}
                    </p>
                    <h3 className="text-lg font-medium text-gray-900">
                      {item.name}
                    </h3>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-center mt-16"
          >
            <button
              onClick={() => setShowCatalog(true)}
              className="inline-block border-2 border-gray-900 text-gray-900 px-12 py-4 rounded-full text-sm font-light tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Collection
            </button>
          </motion.div>
        </div>
      </section>

      {/* Furniture Detail Modal */}
      {selectedFurniture && currentFurniture && (
        <div 
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          onClick={closeFurnitureModal}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeFurnitureModal}
              className="sticky top-4 right-4 float-right z-10 w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-full hover:bg-gray-800 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            {/* Modal Content */}
            <div className="p-8 md:p-12">
              {/* Header */}
              <div className="mb-8">
                <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">{currentFurniture.category}</p>
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{currentFurniture.name}</h2>
              </div>

              {/* Main Image */}
              <div className="w-full h-[400px] rounded-2xl overflow-hidden mb-8">
                <img
                  src={currentFurniture.image}
                  alt={currentFurniture.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>

              {/* Product Info Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div className="bg-[#FAF9F7] rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">Boyutlar</p>
                  <p className="text-lg font-semibold text-gray-900">{currentFurniture.details.dimensions}</p>
                </div>
                <div className="bg-[#FAF9F7] rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">Durum</p>
                  <p className="text-lg font-semibold text-gray-900">Stokta</p>
                </div>
              </div>

              {/* Description */}
              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Ürün Açıklaması</h3>
                <p className="text-gray-600 leading-relaxed text-lg">{currentFurniture.details.description}</p>
              </div>

              {/* Materials */}
              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Malzemeler</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  {currentFurniture.details.materials.map((material, index) => (
                    <div key={index} className="bg-[#FAF9F7] rounded-lg p-4 text-center">
                      <p className="text-gray-700 font-medium">{material}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Features */}
              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Özellikler</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {currentFurniture.details.features.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-gray-900 rounded-full flex-shrink-0"></div>
                      <p className="text-gray-700">{feature}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Gallery */}
              <div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Galeri</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {currentFurniture.details.gallery.map((image, index) => (
                    <div key={index} className="w-full h-64 rounded-xl overflow-hidden group">
                      <img
                        src={image}
                        alt={`${currentFurniture.name} - ${index + 1}`}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Action Button */}
              <div className="mt-8 flex justify-center">
                <button
                  onClick={() => {
                    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                    if (widget) widget.click();
                  }}
                  className="bg-gray-900 text-white px-12 py-4 rounded-full text-sm font-light tracking-wide hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Sipariş Ver
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}

      {/* Catalog Modal */}
      {showCatalog && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl w-full max-w-7xl max-h-[90vh] overflow-y-auto relative">
            {/* Close Button */}
            <button
              onClick={() => setShowCatalog(false)}
              className="sticky top-4 right-4 float-right z-10 w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-full hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            {/* Header */}
            <div className="p-8 border-b border-gray-200">
              <h2 className="text-3xl font-light text-gray-900 mb-2">Mobilya Koleksiyonu</h2>
              <p className="text-gray-600">20 farklı mobilya ürünümüzü keşfedin</p>
            </div>

            {/* Catalog Grid */}
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {furnitureCatalog.map((item) => (
                  <div
                    key={item.id}
                    className="group bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-300 cursor-pointer"
                    onClick={() => setSelectedFurniture(item.id)}
                  >
                    <div className="relative overflow-hidden aspect-[5/6]">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-4 left-4 right-4 text-white">
                          <p className="text-sm font-light">Detayları Görüntüle</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <p className="text-xs text-gray-500 mb-1">{item.category}</p>
                      <h3 className="text-base font-light text-gray-900">{item.name}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Catalog Item Detail Modal */}
      {selectedFurniture && (
        <div 
          className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4 overflow-y-auto"
          onClick={() => setSelectedFurniture(null)}
        >
          <div 
            className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            {(() => {
              const item = furnitureCatalog.find(f => f.id === selectedFurniture);
              if (!item) return null;

              return (
                <>
                  {/* Close Button */}
                  <button
                    onClick={() => setSelectedFurniture(null)}
                    className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-full hover:bg-gray-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>

                  {/* Image */}
                  <div className="relative h-96 overflow-hidden rounded-t-2xl">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-8">
                    <div className="mb-6">
                      <p className="text-sm text-gray-500 mb-2">{item.category}</p>
                      <h2 className="text-3xl font-light text-gray-900 mb-4">{item.name}</h2>
                      <p className="text-gray-600 leading-relaxed">{item.description}</p>
                    </div>

                    {/* Details Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                      {/* Materials */}
                      <div className="bg-gray-50 rounded-xl p-6">
                        <h3 className="text-sm font-medium text-gray-900 mb-3 flex items-center gap-2">
                          <i className="ri-leaf-line text-lg"></i>
                          Malzemeler
                        </h3>
                        <ul className="space-y-2">
                          {item.materials.map((material, idx) => (
                            <li key={idx} className="text-sm text-gray-600 flex items-start gap-2">
                              <i className="ri-checkbox-circle-fill text-green-600 mt-0.5"></i>
                              {material}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Dimensions */}
                      <div className="bg-gray-50 rounded-xl p-6">
                        <h3 className="text-sm font-medium text-gray-900 mb-3 flex items-center gap-2">
                          <i className="ri-ruler-line text-lg"></i>
                          Boyutlar
                        </h3>
                        <p className="text-sm text-gray-600">{item.dimensions}</p>
                      </div>
                    </div>

                    {/* Action Button */}
                    <button className="w-full bg-gray-900 text-white py-4 rounded-full hover:bg-gray-700 transition-colors text-sm font-light tracking-wide whitespace-nowrap cursor-pointer">
                      Ürün Hakkında Bilgi Al
                    </button>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
}
